const TABS = {
    onReady() {
        document.querySelectorAll('.tabs-menu').forEach(tabMenu => {
            Array.from(tabMenu.children).forEach((child, ind) => {
                child.addEventListener('click', () => {
                    TABS.toggle(child.dataset.target);
                    COOKIE.set({
                        name:  'open_tab',
                        value: child.dataset.target,
                        days:  365
                    });
                });
                if (child.className.includes('is-active')) {
                    TABS.toggle(child.dataset.target);
                }
            });
        });
    },
    toggle(targetId) {
        document.querySelectorAll('.tab-content').forEach(contentElement => {
            contentElement.style.display = contentElement.id === targetId ? 'block' : 'none';
            document.querySelector(`[data-target="${contentElement.id}"]`).classList[contentElement.id === targetId ? 'add' : 'remove']('is-active');
        });
    }
};